// extracted by mini-css-extract-plugin
export default {"root":"GeneralDetails_root__uFiMf","tnc-label":"GeneralDetails_tnc-label__mNW+Z"};